import React, {Component} from 'react'
import {connect} from 'react-redux'
import {dataFetches, dataFetchProps, calldataFetches} from './withData/helper'

import CircularProgress from '@material-ui/core/CircularProgress'

// withData function takes a component and wraps a data fetch logic around it
// The fetchrequests parameter contains an array of dataConstants used by
// the calldataFetches function to identify the type of data to fetch
const withData = (WrappedComponent, fetchrequests) => {
    class WithData extends Component {
        componentDidMount() {
            calldataFetches(this.props, fetchrequests)
        }

        componentWillUnmount() {
            // Clear active swipe occurrence to enable auto-logout
            const {setOccurrence} = this.props
            setOccurrence({})
        }

        render() {
            const {eventLoading, occurrenceLoading} = this.props

            return eventLoading || occurrenceLoading ? (
                <div align="center" style={{margin: '200px'}}>
                    <CircularProgress
                        style={{color: '#00853e'}}
                        thickness={5}
                    />
                </div>
            ) : (
                <WrappedComponent props={this.props} />
            )
        }
    }

    // Notice that the usual mapDispatchToProps has been renamed dataFetches
    // dataFetches is imported from the dataConstants file
    return connect(dataFetchProps, dataFetches)(WithData)
}

export default withData
